import { ListCell } from '../../Table'
import { IdwellToIdwellRequestPhaseAsyncMultiValuedList } from '../IdwellToIdwellRequestPhaseAsyncMultiValuedList'

function IdwellToIdwellRequestTableRowPhases({
  id,
  outboundUuid,
  ...restProps
}) {
  return (
    <ListCell
      {...restProps}
      List={IdwellToIdwellRequestPhaseAsyncMultiValuedList}
      listProps={{ id, outboundUuid }}
    />
  )
}

export default IdwellToIdwellRequestTableRowPhases
